<div class="fulfill_screen__tabs-lower">
  <div class="fulfill_screen__edit-column">
    <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
    <mat-select
      #editcolumns
      (click)="openedChange($event)"
      class="table-columns-select"
      panelClass="pdq-mat-select--panel__multi"
      floatlLabel="never"
      [(ngModel)]="selectedColumns"
      (selectionChange)="toggleColumn()"
      [disableOptionCentering]="true"
      multiple
      matTooltipClass="pdq-mat-tooltip"
      [matTooltip]="'Edit columns'">
      <div class="pdq-mat-select--panel--header">
        Showing {{ selectedColumns?.length + '/' + COLUMN_OPTIONS?.length }} columns
      </div>
      @for (column of COLUMN_OPTIONS; track column) {
        <mat-option selected="selected" [value]="column.prop">
          {{ column.name }}
        </mat-option>
      }
    </mat-select>
  </div>
</div>
<div class="fulfill-table">
  <app-table
    [rows]="orders"
    [message]="'emptyMessage'"
    [table]="TABLES.FULFILLMENT"
    [footerHeight]="footerHeight"
    [columnsSettings]="columns"
    [printOptionActions]="tablePrintActions"
    [selected]="selectedOrders"
    [displayTableFooter]="displayTableFooter"
    [rowActions]="rowActions"
    [groupActions]="groupActions"
    [disableBackToAssign]="disableBackToAssign"
    [displayPickList]="true"
    [inWarningOrderIds]="inWarningOrderIds"
    [bannersHeight]="bannersHeight"
    (sort)="sortColumns($event)"
    (updateOrderToDelivered)="updateOrderToDeliveredStatus($event)"
    (onTableActivate)="onActiveRow($event.row)"
    (changeSelectedOrders)="onChangeSelectedOrders($event)"
    (changeFilter)="onChangeTableFilter($event)"
    (returnSelectedOrderToAssign)="onReturnSelectedOrdersToAssign()"
    (returnOrderToAssign)="onReturnOrderToAssign($event)"
    (fulfillSelectedOrders)="onFulfillSelectedOrders()"
    (onBulkPrint)="onBulkPrint($event)"
    (changeColorCoding)="changeColorCoding($event)"></app-table>
</div>
